var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFileCirclePlus = function SvgFileCirclePlus(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 80,
    height: 71,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#file-circle-plus_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#286EFA",
    d: "M31.195 22.375V.5l22.012 21.875zM40 50.813c0-10.87 8.874-19.688 19.811-19.688 10.938 0 19.812 8.818 19.812 19.688S70.749 70.5 59.81 70.5C48.874 70.5 40 61.682 40 50.813m22.012-8.873c0-1.08-.99-2.188-2.2-2.188-1.212 0-2.202 1.107-2.202 2.188v6.562h-6.604c-1.21 0-2.201 1.107-2.201 2.188 0 1.326.99 2.187 2.201 2.187h6.604v6.563c0 1.326.99 2.187 2.201 2.187 1.21 0 2.201-.861 2.201-2.187v-6.563h6.604c1.21 0 2.201-.861 2.201-2.187 0-1.08-.99-2.188-2.2-2.188h-6.605z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#BFD4FE",
    d: "M.377 9.25C.377 4.417 4.32.5 9.182.5h22.013v21.875h22.013v5.277c-10.167 2.858-17.61 12.141-17.61 23.16 0 8.08 4.003 15.217 10.14 19.592-.427.055-.881.096-1.335.096H9.183c-4.864 0-8.806-3.924-8.806-8.75z",
    opacity: 0.4
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "file-circle-plus_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M.377.5h79.245v70H.377z"
  })))));
};
export default SvgFileCirclePlus;